import _ from 'underscore';

import {
  FETCHED_SERVICE_CHILDREN,
  GET_INITIAL_SERVICES,
  FETCHED_PARENT_SERVICES,
  SHOW_EXTENSION_MODAL,
  FETCHED_CATALOGUE_SERVICE,
  CREATED_SERVICE_SUCCESSFUL,
  REMOVED_SERVICE_SUCCESSFUL,
  EDITED_SERVICE_SUCCESSFUL,
  CLEAN_CATALOGUE_STORE,
  FETCH_ADDITIONAL_SERVICES_SUCCESS,
  FETCH_RECOMMENDED_SERVICES_SUCCESS,
  CHANGE_REPEAT_SERVICE,
  MAIN_SERVICE_KM,
  CUSTOM_SERVICE,
  LOADING_CUSTOM_SERVICE,
  SET_MAINSERVICE_LOADING  
} from '../actionTypes/catalogue';

import {
  LOAD_SERVICE_PRICE_SUCCESSFUL,
} from '../actionTypes/operations';
import {
  UPDATE_SERVICE_PRICE_SUCCESSFUL,
  CREATE_SERVICE_PRICE_SUCCESSFUL,
  DELETE_SERVICE_PRICE_SUCCESSFUL,
  SUCCESSFUL_FETCHED_SERVICES
} from '../actionTypes/service';

const INITIAL_STATE = {
  history: [],
  services: [],
  additionalServices: false, // False means not fetched
  service: {},
  modal: {
    show: false,
    type: null,
  },
  datacars: [],
  hasToFetch: false,
  repeatService: false,
  mainServiceKm: false
}

export default function (state = INITIAL_STATE, action) {
  let history, index;
  let services = [...state.services];
  let cleaned = {}
  switch (action.type) {
    case GET_INITIAL_SERVICES:
      return {
        ...INITIAL_STATE,
        services: action.payload.services,
        hasToFetch: false,
        additionalServices: state.additionalServices, // Don't reset the additional Services
        repeatService: state.repeatService,
      }
    case CREATED_SERVICE_SUCCESSFUL:
      // services.push(action.payload.service);
      return {
        ...state,
        services,
        hasToFetch: true,
      }
    case EDITED_SERVICE_SUCCESSFUL:
      // index = _.findIndex(services, (service) => service.serviceId === action.payload.service.serviceId);
      // if (index !== -1) {
      //   services = [...services.slice(0, index), action.payload.service, ...services.slice(index + 1, services.length)];
      // }
      return {
        ...state,
        services,
        hasToFetch: true,
      }
    case REMOVED_SERVICE_SUCCESSFUL:
      // index = _.findIndex(services, (service) => service.serviceId === action.payload.serviceId);
      // if (index !== -1) {
      //   services.splice(index, 1);
      // }
      return {
        ...state,
        services,
        hasToFetch: true,
      }
    case FETCHED_CATALOGUE_SERVICE:
      return {
        ...state,
        service: action.payload.service,
        hasToFetch: false
      };
    case LOAD_SERVICE_PRICE_SUCCESSFUL:
      return {
        ...state,
        datacars: action.payload.data
      }
    case FETCHED_SERVICE_CHILDREN:
      history = [...state.history, action.payload.service];
      return {
        ...state,
        history,
        services: action.payload.services,
        hasToFetch: false
      }
    case FETCHED_PARENT_SERVICES:
      history = [...state.history];
      history.pop();
      return {
        ...state,
        history,
        services: action.payload.services,
        hasToFetch: false
      }
    case SHOW_EXTENSION_MODAL:
      return {
        ...state,
        modal: {
          ...action.payload,
        }
      }
    case CLEAN_CATALOGUE_STORE:
      if (action.payload.props === '*') {
        cleaned = INITIAL_STATE;
      } else if (Array.isArray(action.payload.props)) {
        action.payload.props.forEach((p) => {
          cleaned[p] = INITIAL_STATE[p];
        })
      }
      return {
        ...state,
        ...cleaned,
      }
    case FETCH_ADDITIONAL_SERVICES_SUCCESS:
      return {
        ...state,
        additionalServices: action.payload.additionalServices,
        hasToFetch: false,
      }
    case FETCH_RECOMMENDED_SERVICES_SUCCESS:
      return {
        ...state,
        recommendedServices: action.payload.recommendedServices,
        hasToFetch: false,
      }  
    case CHANGE_REPEAT_SERVICE:
      return {
        ...state,
        repeatService: action.payload.data
      }
    case UPDATE_SERVICE_PRICE_SUCCESSFUL:
    case CREATE_SERVICE_PRICE_SUCCESSFUL:
    case DELETE_SERVICE_PRICE_SUCCESSFUL:
      const index = _.findIndex(services, s => s.serviceId === action.payload.updatedService.serviceId)
      if (index > -1) {
        services[index] = action.payload.updatedService;
      }
      return {
        ...state,
        services,
      }
    case SUCCESSFUL_FETCHED_SERVICES:
      return {
        ...state,
        services: action.payload.services,
      }
      case MAIN_SERVICE_KM:
        return {
          ...state,
          mainServiceKm: action.payload.mainServiceKm,
          loading: false,
      }
    case SET_MAINSERVICE_LOADING:
      return {
        ...state,
        loading: action.payload.value
      }
    case CUSTOM_SERVICE:
      return {
        ...state,
        customService: true,
      }
    case LOADING_CUSTOM_SERVICE:
      return {
        ...state,
        loading: true,
      }
    default:
      return {
        ...state
      };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/catalogueReducer.js